// The one standard for transaction-action pills. Extracted verbatim from the
// event Transactions page so every surface (transactions table, ops feed)
// renders identical styles and labels — edit here, not in page files.

const PILL = 'px-2 py-0.5 inline-flex text-xs leading-5 font-semibold rounded-full'

export function TransactionTypeBadge({ action, amount, cardSale = false }: {
  action: string
  amount: number
  /** A directPay row from a POS card sale (isCardSale). */
  cardSale?: boolean
}) {
  if (action === 'addCredit') {
    if (amount === 0) {
      return (
        <span className={`${PILL} bg-neutral-100 text-neutral-800 dark:bg-neutral-900/20 dark:text-neutral-400`}>
          Initialize
        </span>
      )
    }
    return (
      <span className={`${PILL} bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-400`}>
        Reload
      </span>
    )
  }
  if (action === 'spendCredit') {
    return (
      <span className={`${PILL} bg-orange-100 text-orange-800 dark:bg-orange-900/20 dark:text-orange-400`}>
        Order
      </span>
    )
  }
  if (action === 'transfer') {
    return (
      <span className={`${PILL} bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-400`}>
        Transfer
      </span>
    )
  }
  if (action === 'refund') {
    return (
      <span className={`${PILL} bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-400`}>
        Refund
      </span>
    )
  }
  if (action === 'voucherCredit' || action?.toLowerCase().includes('voucher')) {
    return (
      <span className={`${PILL} bg-purple-100 text-purple-800 dark:bg-purple-900/20 dark:text-purple-400`}>
        Voucher Credit
      </span>
    )
  }
  if (action === 'directPay') {
    return (
      <span className={`${PILL} bg-pink-100 text-pink-800 dark:bg-pink-900/20 dark:text-pink-400`}>
        {cardSale ? 'Card Sale' : 'Direct Pay'}
      </span>
    )
  }
  return (
    <span className={`${PILL} bg-neutral-100 text-neutral-800 dark:bg-neutral-900/20 dark:text-neutral-400`}>
      {action || 'Unknown'}
    </span>
  )
}
